import WeeklyPictures from './WeeklyPictures'
export default WeeklyPictures
